module.exports = __webpack_public_path__ + "img/scalability-3.a1d4a27c.png";